import { formatDate, formatTimeAgo } from '@utils/utils.ts';

/**
 * Relative time for a notification (ZLAYT-1423). A generation notification is
 * created when the job starts and flipped to Completed when it ends, so
 * created_at is the start; status_changed_at (newer backends) is when the
 * current status was set. Negative ages (client clock behind the server) are
 * clamped to "few sec ago".
 */
export function notificationTimeLabel(
  n: { created_at: string; status_changed_at?: string | null },
  now: Date = new Date()
): string {
  const date = new Date(n.status_changed_at || n.created_at);
  const hours = Math.max(0, (now.getTime() - date.getTime()) / 3_600_000);
  return hours < 24 ? formatTimeAgo(hours) : formatDate(date);
}
